export const updateAssessmentAction = assessment => {
  // console.log(assessment);

  return {
    type: 'UPDATE_ASSESSMENT',
    data: assessment,
  };
};
